import { Component, Input } from '@angular/core';
import {
  CtBinaryOperator,
  CtControlConfiguration,
  CtControlService,
  CtControlTypes,
  CtModelConfiguration,
  CTModelDatatableFilter,
  CtModelDatatableOperators,
  CtModelService,
  CtSelectControlOptions,
  CtSelectControlValue,
  CtSortOrderDescriptorParameter,
  CtThemeTypes
} from "@ctsolution/ct-framework";
import { FormBuilder, FormGroup } from "@angular/forms";
import { QtaControl } from "../../../../../_core/constants";
import { CtWebapiGenericResponse, DataRequest, MethodEnum } from "@ctsolution/ct-webapi";
import { ModuleCreationRequestParameter } from "../../../../../_core/classes/module-creation-request-parameter";
import { TransferItemsRequestParameter } from "../../../../../_core/classes/transfer-items-request-parameter";
import { LocationRouteData } from 'projects/ct-manager/src/app/_core/route-data/location.route-data';

@Component({
  selector: 'app-module-create-form',
  templateUrl: './module-create-form.component.html',
  styleUrls: ['./module-create-form.component.scss']
})
export class ModuleCreateFormComponent {

  @Input() parameter: ModuleCreationRequestParameter | TransferItemsRequestParameter | null = null;

  qtyControl: CtControlConfiguration = QtaControl("qty").setLabel("quantity");

  locationToControl: CtControlConfiguration =
    this.controlService.getDefaultConfiguration({
      name: 'LocationToOid',
      label: 'locationTo',
      type: CtControlTypes.LOOKUP,
      required: true,
      remoteValueOptionsEndpoint: DataRequest
        .create()
        .setController(['Location'])
        .setAction('Lookup')
        .setMethod(MethodEnum.POST)
        .setQueryParams({ hideSpinner: true })
    })
      .setTheme(CtThemeTypes.MATERIAL)
      .configureOptions<CtSelectControlOptions>(options => {

        if (!options) options = CtSelectControlOptions.create();

        options
          .setNullValueEnabled(false)
          .setLookupFilter((value) => {

            const filters: CTModelDatatableFilter[] = [
              CTModelDatatableFilter
                .create()
                .setField('LoadPermitted')
                .setValue(true)
                .setOperatorType(CtBinaryOperator.Equal),
            ];

            if (value) {

              filters
                .push(
                  CTModelDatatableFilter.create().setField('Name').setValue(value).setOperatorType(CtBinaryOperator.Contains))
            }

            if (this.parameter instanceof TransferItemsRequestParameter) {

              filters
                .push(
                  CTModelDatatableFilter
                    .create()
                    .setField('WorkOrder.Oid')
                    .setValue(this.parameter.WorkOrderOid)
                    .setOperatorType(CtBinaryOperator.Equal)
                )

            }

            if (this.parameter instanceof ModuleCreationRequestParameter) {

              filters
                .push(
                  CTModelDatatableFilter
                    .create()
                    .setField('UnloadPermitted')
                    .setValue(true)
                    .setOperatorType(CtBinaryOperator.Equal),

                  CTModelDatatableFilter
                    .create()
                    .setField('WorkOrder')
                    .setValue(null)
                    .setOperatorType(CtBinaryOperator.Equal),
                )
            }

            const operators = CtModelDatatableOperators
              .create()
              .setFilters(filters);

            operators
              .Pagination
              ?.setSortOrders(new Array<CtSortOrderDescriptorParameter>(CtSortOrderDescriptorParameter.create('Name')))

            return operators;

          })

      });

  form: FormGroup;

  viewModel = {
    warning: 'ModuleCreateForm.Warning'
  }

  get needsQuantity() {

    return this.parameter instanceof ModuleCreationRequestParameter;

  }

  constructor(
    private controlService: CtControlService,
    private formBuilder: FormBuilder,
    private modelService: CtModelService<any>) {

    this.form = this.formBuilder.group({});

    this.qtyControl
      .setFormParent(this.form);

    this.locationToControl
      .setFormParent(this.form);

  }

  ngOnInit() {

    this.setupModel();

  }

  setupModel() {

    if (this.parameter instanceof TransferItemsRequestParameter) {

      this.viewModel.warning = "workOrderImport.warning";

      this.qtyControl
        .control
        ?.setValidators(null);

      this.qtyControl
        .control
        ?.updateValueAndValidity();

      const modelConfiguration = CtModelConfiguration.create().setRouteData(LocationRouteData());
      const body = CtModelDatatableOperators.create().setFilters([
        CTModelDatatableFilter
          .create()
          .setField('WorkOrder.Oid')
          .setValue(this.parameter.WorkOrderOid)
          .setOperatorType(CtBinaryOperator.Equal)]);

      this.modelService.getList(modelConfiguration, body).subscribe((result: CtWebapiGenericResponse<any>) => {

        if (result && result.Result && result.Result.DataSource && result.Result.DataSource.length === 1) {

          this.locationToControl.setValue(CtSelectControlValue.create().setValue(result.Result.DataSource[0].Oid).setLabel(result.Result.DataSource[0].Name ?? null));

        }
      });


    }

  }

}
